import { Action } from '@ngrx/store'
import { Lecture } from '../models'

export const SET_LECTURES = '[Lecture] Set Lectures'
export const SELECT_LECTURE = '[Lecture] Select Lecture'
export const ADD_LECTURE = '[Lecture] Add Lecture'

export class SetLectures implements Action {
  readonly type = SET_LECTURES

  constructor(public lectures: Lecture[]) { }
}

export class SelectLecture implements Action {
  readonly type = SELECT_LECTURE

  constructor(public lecture: Lecture) {}
}

export class AddLecture implements Action {
  readonly type = ADD_LECTURE

  constructor(public lecture: Lecture) { }
}

export type All = SetLectures | SelectLecture | AddLecture



// WEBPACK FOOTER //
// ./src/actions/lecture.ts